export var Type;
(function (Type) {
    Type["UNKNOWN"] = "UNKNOWN";
    Type["PAID_PLANS"] = "PAID_PLANS";
})(Type || (Type = {}));
export var ContentType;
(function (ContentType) {
    ContentType["PLAIN_TEXT"] = "PLAIN_TEXT";
    ContentType["DRAFTJS"] = "DRAFTJS";
    ContentType["RICH_CONTENT"] = "RICH_CONTENT";
})(ContentType || (ContentType = {}));
export var SocialIdentityType;
(function (SocialIdentityType) {
    SocialIdentityType["ANONYMOUS"] = "ANONYMOUS";
    SocialIdentityType["MEMBER"] = "MEMBER";
    SocialIdentityType["USER"] = "USER";
    SocialIdentityType["SERVICE"] = "SERVICE";
    /** indicates everyone who is a member of a group */
    SocialIdentityType["MEMBER_GROUP"] = "MEMBER_GROUP";
})(SocialIdentityType || (SocialIdentityType = {}));
export var MediaType;
(function (MediaType) {
    MediaType["ATTACHMENT"] = "ATTACHMENT";
    MediaType["IMAGE"] = "IMAGE";
    MediaType["VIDEO"] = "VIDEO";
    MediaType["FILE"] = "FILE";
})(MediaType || (MediaType = {}));
/** Comment actions */
export var UserAction;
(function (UserAction) {
    UserAction["VIEW"] = "VIEW";
    UserAction["ADD_COMMENT"] = "ADD_COMMENT";
    UserAction["REACT"] = "REACT";
    UserAction["UNREACT"] = "UNREACT";
    UserAction["REPORT"] = "REPORT";
    UserAction["EDIT"] = "EDIT";
    UserAction["DELETE"] = "DELETE";
    UserAction["VIEW_REPORT"] = "VIEW_REPORT";
})(UserAction || (UserAction = {}));
/** Report abuse types */
export var ReportType;
(function (ReportType) {
    ReportType["UNWANTED_CONTENT"] = "UNWANTED_CONTENT";
    ReportType["HARASSMENT"] = "HARASSMENT";
    ReportType["INAPPROPRIATE_CONTENT"] = "INAPPROPRIATE_CONTENT";
    ReportType["HATE_SPEECH_OR_GRAPHIC"] = "HATE_SPEECH_OR_GRAPHIC";
    ReportType["OTHER"] = "OTHER";
    /** deprecated, use UNWANTED_CONTENT */
    ReportType["UnwantedContent"] = "UnwantedContent";
    /** deprecated, use HARASSMENT */
    ReportType["Harrasment"] = "Harrasment";
    /** deprecated, use INAPPROPRIATE_CONTENT */
    ReportType["InappropiateContent"] = "InappropiateContent";
    /** deprecated, use HATE_SPEECH_OR_GRAPHIC */
    ReportType["HateSpeechOrGraphic"] = "HateSpeechOrGraphic";
})(ReportType || (ReportType = {}));
export var IdentityType;
(function (IdentityType) {
    IdentityType["VISITOR"] = "VISITOR";
    IdentityType["MEMBER"] = "MEMBER";
    IdentityType["USER"] = "USER";
    IdentityType["SERVICE"] = "SERVICE";
    IdentityType["EXTERNAL_APP"] = "EXTERNAL_APP";
    IdentityType["CACHE"] = "CACHE";
})(IdentityType || (IdentityType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var OnExceedAllowedPins;
(function (OnExceedAllowedPins) {
    OnExceedAllowedPins["RESPOND_WITH_ALREADY_EXISTS"] = "RESPOND_WITH_ALREADY_EXISTS";
    OnExceedAllowedPins["REPLACE_OLDEST"] = "REPLACE_OLDEST";
})(OnExceedAllowedPins || (OnExceedAllowedPins = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map